export class GetProject {
  public static readonly type = '[Project] GetProject';
  constructor(public readonly id: string) {}
}
